export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Purchase & Get Instant Access',
      description: 'Get instant access to the Canva template pack, captions, reel hooks, and your 30-day content calendar.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Open in Canva — Customize in Minutes',
      description: 'Add your photo, name, and colors in minutes. Every template is fully editable and ready to brand.',
      icon: 'ri-palette-line'
    },
    {
      number: '03',
      title: 'Follow the Calendar — Post Daily, Grow Consistently',
      description: 'Post daily, grow consistently, attract clients. Your content system runs on autopilot.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From purchase to posting in less than 5 minutes.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-white p-8 rounded-2xl border border-black/6 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10),0_30px_60px_rgba(0,0,0,0.14)] transition-all duration-200 hover:-translate-y-1"
              style={{
                boxShadow: '0 6px 12px rgba(0,0,0,0.06), 0 18px 40px rgba(0,0,0,0.10)'
              }}
            >
              <div className="absolute -top-4 -left-4 w-12 h-12 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-lg">
                {step.number}
              </div>
              <div className="w-14 h-14 rounded-full bg-[#E8603C] flex items-center justify-center mb-6 mt-4">
                <i className={`${step.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}